import styled from "styled-components"

export const BillingHeader = styled.div`
  display: flex;
  flex-direction: column;
`
